
// /* Loads a script. */
// function loadScript(src) {
//   return new Promise((resolve, reject) => {
//     const s = document.createElement('script');
//     s.src = src;
//     s.onload = resolve;
//     s.onerror = reject;
//     document.body.appendChild(s);
//   });
// }

// /* global DetailsDisclosure, trapFocus, removeTrapFocus */
// if (!customElements.get('cart-drawer-disclosure')) {
//   class CartDrawerDisclosure extends DetailsDisclosure {
//     constructor() {
//       super();
//       this.openBtn = this.querySelector('summary');
//       this.closeBtn = this.querySelector('.js-close');
//       this.overlay = document.getElementById('cart-drawer').querySelector('.overlay');
//     }

//     handleClick(evt) {
//       if (!evt.target.matches('.js-close')) return;
//       this.close();
//     }

//     open() {
//       this.overlay.classList.add('is-visible');
//       super.open();
//       trapFocus(this);

//       this.clickHandler = this.clickHandler || this.handleClick.bind(this);
//       this.keyupHandler = (evt) => evt.key === 'Escape' && this.close();

//       this.addEventListener('click', this.clickHandler);
//       this.addEventListener('keyup', this.keyupHandler);
//       this.overlay.addEventListener('click', this.clickHandler);
//     }

//     close() {
//       this.overlay.classList.remove('is-visible');
//       super.close();
//       removeTrapFocus(this.openBtn);

//       this.removeEventListener('click', this.clickHandler);
//       this.removeEventListener('keyup', this.keyupHandler);
//       this.overlay.removeEventListener('click', this.clickHandler);
//     }
//   }

//   customElements.define('cart-drawer-disclosure', CartDrawerDisclosure);
// }

// /* global SideDrawer */
// if (!customElements.get('cart-drawer')) {
//   class CartDrawer extends SideDrawer {
//     constructor() {
//       super();

//       this.cartSummary = this.querySelector('.cart-drawer__summary');
//       this.init();
//       this.bindEvents();

//       // ✅ Bind custom remove logic
//       this.bindRemoveByIds();

//   // ✅ Bind coupon code form
//   this.initCouponForm();
//   this.initSpecificProductEvent();
//     }

//     disconnectedCallback() {
//       document.removeEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);
//       document.removeEventListener('on:bfcache:load-restore', this.refreshHandler);
//       document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//       document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);

//       if (Shopify.designMode) {
//         document.removeEventListener('shopify:section:select', this.sectionSelectHandler);
//         document.removeEventListener('shopify:section:deselect', this.sectionDeselectHandler);
//       }

//       if (this.dcbLoadedHandler) {
//         document.removeEventListener('shopify:payment_button:loaded', this.dcbLoadedHandler);
//       }
//     }

//     init() {
//       const cartIcon = document.getElementById('cart-icon');
//       if (cartIcon) {
//         cartIcon.setAttribute('role', 'button');
//         cartIcon.setAttribute('aria-haspopup', 'dialog');

//         cartIcon.addEventListener('click', (evt) => {
//           evt.preventDefault();
//           this.open(cartIcon);
//         });

//         cartIcon.addEventListener('keydown', (evt) => {
//           if (evt.key !== ' ') return;
//           evt.preventDefault();
//           this.open(cartIcon);
//         });
//       }
//     }

//     bindEvents() {
//       if (Shopify.designMode) {
//         this.sectionSelectHandler = this.handleSectionSelect.bind(this);
//         this.sectionDeselectHandler = this.handleSectionDeselect.bind(this);
//         document.addEventListener('shopify:section:select', this.sectionSelectHandler);
//         document.addEventListener('shopify:section:deselect', this.sectionDeselectHandler);
//       }

//       this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
//       this.closeDrawerViaEventHandler = this.close.bind(this, null);
//       document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//       document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);

//       if (this.cartSummary.classList.contains('cart-drawer--checkout--sticky-true')) {
//         this.dcbLoadedHandler = this.dcbLoadedHandler || CartDrawer.recalculateCssVarHeights;
//         document.addEventListener('shopify:payment_button:loaded', this.dcbLoadedHandler);
//       }

//       this.refreshHandler = this.refresh.bind(this);
//       document.addEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);
//       document.addEventListener('on:bfcache:load-restore', this.refreshHandler);
//     }

// bindRemoveByIds() {
//   document.addEventListener("click", async (e) => {
//     const btn = e.target.closest("[data-id-to-remove]");
//     if (!btn) return;

//     e.stopImmediatePropagation();
//     e.preventDefault();

//     // 🎯 Get exact parent (cart item container)
//     const parentSelector = btn.getAttribute("data-target-parent");
//     const parentEl = parentSelector ? document.querySelector(parentSelector) : null;

//     if (parentEl) {
//       parentEl.classList.add("pointer-events-none"); // ✅ disable clicks
//       parentEl.style.opacity = "0.3"; // ✅ minor opacity effect
//       const loader = parentEl.querySelector(".cart-item__loader");
//       if (loader) loader.hidden = false; // ✅ show loader
//     }

//     // Collect variant IDs
//     let idsToRemove = (btn.getAttribute("data-id-to-remove") || "")
//       .split(",")
//       .map((id) => id.trim())
//       .filter(Boolean);

//     const href = btn.getAttribute("href");
//     if (href) {
//       const match = href.match(/id=(\d+)(?=:)/);
//       if (match) idsToRemove.push(match[1]);
//     }

//     if (idsToRemove.length === 0) {
//       if (parentEl) {
//         parentEl.classList.remove("pointer-events-none");
//         parentEl.style.opacity = "1"; // ✅ reset opacity
//         const loader = parentEl.querySelector(".cart-item__loader");
//         if (loader) loader.hidden = true;
//       }
//       return;
//     }

//     try {
//       // Fetch current cart
//       const cart = await fetch("/cart.js").then((res) => res.json());

//       // Build updates object
//       const updates = {};
//       cart.items.forEach((item) => {
//         if (idsToRemove.includes(item.variant_id.toString())) {
//           updates[item.key] = 0;
//         }
//       });

//       // Apply update
//       if (Object.keys(updates).length > 0) {
//         await fetch("/cart/update.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ updates }),
//         });
//       }

//       // Refresh cart
//       this.refresh();
//     } catch (err) {
//       console.error("Error removing items:", err);
//     } finally {
//       // ✅ Always hide loader & re-enable clicks
//       if (parentEl) {
//         parentEl.classList.remove("pointer-events-none");
//         parentEl.style.opacity = "1"; // ✅ reset opacity
//         const loader = parentEl.querySelector(".cart-item__loader");
//         if (loader) loader.hidden = true;
//       }
//     }
//   });
// }

// // ✅ Initialize discount form
// initCouponForm() {
//   const couponInput = this.querySelector('input[name="custom-discount-input"]');
//   const couponApply = this.querySelector('.submit-discount');
//   const couponError = this.querySelector('.custom-discount-form .error');
//   const couponRemove = this.querySelectorAll('.remove-discount');

//   // Hide error initially
//   if (couponError) {
//     couponError.style.display = 'none';
//   }

//   // --- Apply coupon ---
//   if (couponApply && couponInput) {
//     couponApply.addEventListener('click', async (e) => {
//       e.preventDefault();

//       const code = couponInput.value.trim();
//       if (!code) {
//         if (couponError) {
//           couponError.innerText = 'Please enter a discount code';
//           couponError.style.display = 'block';
//         }
//         return;
//       }

//       const targetUrl = `/discount/${encodeURIComponent(code)}`;

//       couponApply.disabled = true;
//       const oldText = couponApply.innerText;
//       couponApply.innerText = 'Applying...';
//       if (couponError) couponError.style.display = 'none';

//       try {
//         const res = await fetch(targetUrl, { method: 'GET' });

//         // If request fails, show error
//         if (!res.ok) {
//           if (couponError) {
//             couponError.innerText = 'Invalid discount code';
//             couponError.style.display = 'block';
//           }
//         }

//         // Refresh cart drawer
//         document.dispatchEvent(
//           new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })
//         );
//       } catch (err) {
//         console.error('Coupon apply error:', err);
//         if (couponError) {
//           couponError.innerText = 'Something went wrong, try again';
//           couponError.style.display = 'block';
//         }
//       } finally {
//         couponApply.disabled = false;
//         couponApply.innerText = oldText;
//       }
//     });
//   }
//   // --- Remove coupon(s) ---
// if (couponRemove.length > 0) {
//   couponRemove.forEach((btn) => {
//     btn.addEventListener('click', async (e) => {
//       e.preventDefault();

//       btn.disabled = true;
//       const oldHtml = btn.innerHTML;
//       btn.innerHTML = '...';

//       try {
//         // Clear discount by sending empty discount to cart
//         await fetch('/cart/update.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({ discount: '' })
//         });

//         // Refresh cart drawer
//         document.dispatchEvent(
//           new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })
//         );
//       } catch (err) {
//         console.error('Coupon remove error:', err);
//       } finally {
//         btn.disabled = false;
//         btn.innerHTML = oldHtml;
//       }
//     });
//   });
// }
// }


// // --- Initialize Specific Product Event ---

// initSpecificProductEvent() {
//   // Use a different variant ID for the local storage key to avoid conflicts
//   const specificVariantId = 46692864065836; 
//   const toggleBtn = this.querySelector(".toggle_button_atc");

//   if (!toggleBtn) return;

//   // --- Local State Management ---
//   // Use local storage to remember the user's explicit action across page loads/refreshes.
//   // 'specific_product_removed_by_user_[ID]' will be 'true' or 'false'
//   const LOCAL_STORAGE_KEY = `specific_product_removed_by_user_${specificVariantId}`;

//   const setRemovedState = (isRemoved) => {
//     localStorage.setItem(LOCAL_STORAGE_KEY, isRemoved ? 'true' : 'false');
//   };
//   const getRemovedState = () => {
//     return localStorage.getItem(LOCAL_STORAGE_KEY) === 'true';
//   };
//   // -----------------------------

//   // Variables for state management (transient, for immediate action control)
//   let isProcessing = false; // Prevents concurrent API calls
  
//   // --- Toggle State Handlers ---
//   const setToggleActive = () => {  
//     toggleBtn.classList.add("active");  
//   }
//   const setToggleInactive = () => {  
//     toggleBtn.classList.remove("active");  
//   }
//   // -----------------------------

//   // Helper to trigger the cart drawer refresh event
//   const refreshCartDrawer = () => {
//     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
//   }

//   // Helper to fetch the cart data
//   const fetchCart = async () => {
//       return await fetch("/cart.js").then(res => res.json());
//   };

//   /**
//    * Adds the specific product to the cart.
//    * Clears the 'removed by user' flag in local storage.
//    */
//   const addSpecificProduct = async (shouldRefresh = true) => {
//     if (isProcessing) return;
//     isProcessing = true;
    
//     try {
//       await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: specificVariantId, quantity: 1 })
//       });

//       setRemovedState(false); // User wants it now, so reset the "removed" flag
//       setToggleActive();
//       if (shouldRefresh) refreshCartDrawer();
//     } catch (err) {
//       console.error("Error adding specific product:", err);
//     } finally {
//       isProcessing = false;
//     }
//   };

//   /**
//    * Removes the specific product from the cart completely (sets quantity to 0).
//    * Sets the 'removed by user' flag in local storage.
//    */
//   const removeSpecificProduct = async () => {
//     if (isProcessing) return;
//     isProcessing = true;
    
//     try {
//       // 1. SET FLAG: Tell the system the user is intentionally removing it
//       setRemovedState(true); 
      
//       const cart = await fetchCart();
//       const item = cart.items.find(i => i.id === specificVariantId);

//       if (!item) {
//         setToggleInactive();
//         refreshCartDrawer();
//         return; // Already gone
//       }

//       // Remove item by setting quantity to 0
//       await fetch("/cart/update.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ updates: { [item.key]: 0 } })
//       });

//       setToggleInactive();
//       refreshCartDrawer(); // Refresh after removal
      
//     } catch (err) {
//       console.error("Error removing specific product:", err);
//       setRemovedState(false); // Clear flag if removal failed
//     } finally {
//       isProcessing = false;
//     } 
//   };

//   // --- Core State Check/Fix Function (Runs on load and refresh) ---
//   // --- Core State Check/Fix Function (Runs on load and refresh) ---
// const checkAndEnsureProduct = async () => {
//   if (isProcessing) return;

//   try {
//     const cart = await fetchCart();
    
//     // Calculate how many OTHER items are in the cart (Excluding the specific product itself)
//     const otherItemCount = cart.items
//       .filter(item => item.id !== specificVariantId)
//       .reduce((sum, item) => sum + item.quantity, 0);

//     const specificProductExists = cart.items.some(item => item.id === specificVariantId);
//     const otherProductsExist = otherItemCount > 0;
//     const userHasRemoved = getRemovedState(); // Check local storage

//     // --- New Logic: If ONLY the specific product remains, remove it ---
//     if (specificProductExists && !otherProductsExist) {
//       console.log(`Only specific product ${specificVariantId} remains. Removing it.`);
//       // Directly call the update API to remove it
//       const item = cart.items.find(i => i.id === specificVariantId);
//       if (item) {
//         await fetch("/cart/update.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ updates: { [item.key]: 0 } })
//         });
//         setRemovedState(false); // Reset flag as the cart is now empty/cleared by the system
//         setToggleInactive();
//         refreshCartDrawer();
//       }
//       return; // Stop processing, as the cart has been modified and a refresh is triggered
//     }
//     // ------------------------------------------------------------------

//     // 1. User actively removed the product
//     if (userHasRemoved) {
//       // If product exists *despite* the flag, remove it and keep flag
//       if (specificProductExists) {
//         // This case handles external adds (e.g., another script) after user removal
//         console.log("User previously removed product. Removing again.");
//         // Directly call the update API to remove it without re-setting the flag
//         const item = cart.items.find(i => i.id === specificVariantId);
//         if (item) {
//           await fetch("/cart/update.js", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ updates: { [item.key]: 0 } })
//           });
//           refreshCartDrawer();
//         }
//       }
//       setToggleInactive();
//       return;
//     }
    
//     // 2. Product is missing, but other items are in the cart (Auto-Add Logic)
//     if (!specificProductExists && otherProductsExist) {
//       console.log(`Other items present (${otherItemCount}). Auto-adding specific product ${specificVariantId}.`);
//       // Use addSpecificProduct to handle the add and refresh logic
//       await addSpecificProduct(true);
      
//     // 3. Product exists (Ensure state is correct)
//     } else if (specificProductExists) {
//       setToggleActive();
      
//     // 4. Cart is empty (or only contains non-specific items and auto-add isn't triggered)
//     } else {
//       setToggleInactive();
//     }

//   } catch (err) {
//     console.error("Error in checkAndEnsureProduct:", err);
//     setToggleInactive();
//   }
// };
//   // -----------------------------------------------------------------

//   // Manual toggle click handler
//   toggleBtn.addEventListener("click", () => {
//     // Prevent interaction while an API call is ongoing
//     if (isProcessing) return; 
    
//     if (toggleBtn.classList.contains("active")) {
//       removeSpecificProduct();
//     } else {
//       addSpecificProduct();
//     }
//   });

//   // 1. Initial State Check on Page Load
//   checkAndEnsureProduct();

//   // 2. Listen for cart refresh events to maintain the state
//   // This listener is crucial for reacting to other items being added/removed
//   document.addEventListener('dispatch:cart-drawer:refresh', checkAndEnsureProduct);
// }


//     handleSectionSelect(evt) {
//       if (evt.target === this.closest('.shopify-section')) this.open();
//     }

//     handleSectionDeselect(evt) {
//       if (evt.target === this.closest('.shopify-section')) this.close();
//     }

//     handleDrawerOpenViaEvent(evt) {
//       this.open(evt.detail ? evt.detail.opener : null);
//     }

//     open(opener, elementToFocus) {
//       const quickAddDrawer = document.querySelector('quick-add-drawer[aria-hidden="false"]');
//       const overlay = document.querySelector('.js-overlay.is-visible');

//       if (quickAddDrawer) {
//         if (overlay) overlay.style.transitionDelay = '200ms';
//         quickAddDrawer.close();
//       }

//       setTimeout(() => {
//         super.open(opener, elementToFocus, () => {
//           if (this.cartSummary.classList.contains('cart-drawer--checkout--sticky-true')) {
//             CartDrawer.recalculateCssVarHeights();
//           }
//         });

//         if (this.cartSummary.classList.contains('cart-drawer--checkout--sticky-true')) {
//           CartDrawer.recalculateCssVarHeights();
//         }

//         if (overlay) overlay.style.transitionDelay = '';
//       }, quickAddDrawer ? 200 : 0);
//     }

//     async refresh(dontRefreshCartItems) {
//       try {
//         const cartItems = this.querySelector('cart-items');
//         if (cartItems && !dontRefreshCartItems) {
//           cartItems.refresh();
//         } else {
//           const response = this.getSectionsToRender().map((section) => section.section);
//           const cartResponse = await fetch(`?sections=${response.join(',')}`);
//           const sections = await cartResponse.json();
//           this.renderContents({ sections }, false);
//           CartDrawer.recalculateCssVarHeights();
//         }
//       } catch (error) {
//         console.log(error);
//         this.dispatchEvent(new CustomEvent('on:cart:error', {
//           bubbles: true,
//           detail: {
//             error: this.errorMsg?.textContent
//           }
//         }));
//       }
//     }

//     async renderContents(data, openDrawer = true) {
//       if (!this.scriptsLoaded) {
//         if (!document.querySelector(`script[src="${theme.scripts.cartItems}"]`)) {
//           await loadScript(theme.scripts.cartItems);
//         }

//         if (!document.querySelector(`script[src="${theme.scripts.shippingCalculator}"]`) && this.dataset.shippingCalculator) {
//           await loadScript(theme.scripts.countryProvinceSelector);
//           await loadScript(theme.scripts.shippingCalculator);
//         }

//         this.scriptsLoaded = true;
//       }

//       this.getSectionsToRender().forEach((section) => {
//         const el = document.getElementById(section.id);
//         if (el) {
//           el.innerHTML = CartDrawer.getElementHTML(
//             data.sections[section.section],
//             section.selector
//           );
//         }
//       });

//       if (openDrawer && this.getAttribute('open') === null) {
//         setTimeout(() => this.open());
//       }
//       this.initCouponForm();
//       this.initSpecificProductEvent();
//     }

//     getSectionsToRender() {
//       return [
//         {
//           id: 'cart-drawer',
//           section: this.closest('.shopify-section').id.replace('shopify-section-', ''),
//           selector: 'cart-drawer'
//         },
//         {
//           id: 'cart-icon-bubble',
//           section: 'cart-icon-bubble',
//           selector: '.shopify-section'
//         }
//       ];
//     }

//     static recalculateCssVarHeights() {
//       window.requestAnimationFrame(() => {
//         document.dispatchEvent(new CustomEvent('on:css-var-height:update'));
//       });
//     }

//     static getElementHTML(html, selector) {
//       const tmpl = document.createElement('template');
//       tmpl.innerHTML = html;
//       return tmpl.content.querySelector(selector).innerHTML;
//     }
//   }

//   customElements.define('cart-drawer', CartDrawer);
// }
 






/* Loads a script */
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.body.appendChild(s);
  });
}

/* global DetailsDisclosure, trapFocus, removeTrapFocus */
if (!customElements.get('cart-drawer-disclosure')) {
  class CartDrawerDisclosure extends DetailsDisclosure {
    constructor() {
      super();
      this.openBtn = this.querySelector('summary');
      this.closeBtn = this.querySelector('.js-close');
      this.overlay = document.getElementById('cart-drawer').querySelector('.overlay');
    }

    handleClick(evt) {
      if (!evt.target.matches('.js-close')) return;
      this.close();
    }

    open() {
      this.overlay.classList.add('is-visible');
      super.open();
      trapFocus(this);

      this.clickHandler = this.clickHandler || this.handleClick.bind(this);
      this.keyupHandler = (evt) => evt.key === 'Escape' && this.close();

      this.addEventListener('click', this.clickHandler);
      this.addEventListener('keyup', this.keyupHandler);
      this.overlay.addEventListener('click', this.clickHandler);
    }

    close() {
      this.overlay.classList.remove('is-visible');
      super.close();
      removeTrapFocus(this.openBtn);

      this.removeEventListener('click', this.clickHandler);
      this.removeEventListener('keyup', this.keyupHandler);
      this.overlay.removeEventListener('click', this.clickHandler);
    }
  }

  customElements.define('cart-drawer-disclosure', CartDrawerDisclosure);
}

/* global SideDrawer */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends SideDrawer {
    constructor() {
      super();

      this.cartSummary = this.querySelector('.cart-drawer__summary');
      this.init();
      this.bindEvents();

      // Custom remove logic
      this.bindRemoveByIds();

      // Coupon form
      this.initCouponForm();

      // Specific product toggle logic
      this.initSpecificProductEvent();
    }

    disconnectedCallback() {
      document.removeEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);
      document.removeEventListener('on:bfcache:load-restore', this.refreshHandler);
      document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
      document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);

      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:select', this.sectionSelectHandler);
        document.removeEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }

      if (this.dcbLoadedHandler) {
        document.removeEventListener('shopify:payment_button:loaded', this.dcbLoadedHandler);
      }
    }

    init() {
      const cartIcon = document.getElementById('cart-icon');
      if (cartIcon) {
        cartIcon.setAttribute('role', 'button');
        cartIcon.setAttribute('aria-haspopup', 'dialog');

        cartIcon.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.open(cartIcon);
        });

        cartIcon.addEventListener('keydown', (evt) => {
          if (evt.key !== ' ') return;
          evt.preventDefault();
          this.open(cartIcon);
        });
      }
    }

    bindEvents() {
      if (Shopify.designMode) {
        this.sectionSelectHandler = this.handleSectionSelect.bind(this);
        this.sectionDeselectHandler = this.handleSectionDeselect.bind(this);
        document.addEventListener('shopify:section:select', this.sectionSelectHandler);
        document.addEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }

      this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
      this.closeDrawerViaEventHandler = this.close.bind(this, null);
      document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
      document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);

      if (this.cartSummary.classList.contains('cart-drawer--checkout--sticky-true')) {
        this.dcbLoadedHandler = this.dcbLoadedHandler || CartDrawer.recalculateCssVarHeights;
        document.addEventListener('shopify:payment_button:loaded', this.dcbLoadedHandler);
      }

      this.refreshHandler = this.refresh.bind(this);
      document.addEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);
      document.addEventListener('on:bfcache:load-restore', this.refreshHandler);
    }

    // ------------------ REMOVE BY ID ------------------
    bindRemoveByIds() {
      document.addEventListener("click", async (e) => {
        const btn = e.target.closest("[data-id-to-remove]");
        if (!btn) return;

        e.stopImmediatePropagation();
        e.preventDefault();

        const parentSelector = btn.getAttribute("data-target-parent");
        const parentEl = parentSelector ? document.querySelector(parentSelector) : null;

        if (parentEl) {
          parentEl.classList.add("pointer-events-none");
          parentEl.style.opacity = "0.3";
          const loader = parentEl.querySelector(".cart-item__loader");
          if (loader) loader.hidden = false;
        }

        let idsToRemove = (btn.getAttribute("data-id-to-remove") || "")
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean);

        if (idsToRemove.length === 0) {
          if (parentEl) {
            parentEl.classList.remove("pointer-events-none");
            parentEl.style.opacity = "1";
            const loader = parentEl.querySelector(".cart-item__loader");
            if (loader) loader.hidden = true;
          }
          return;
        }

        try {
          const cart = await fetch("/cart.js").then((res) => res.json());
          const updates = {};

          cart.items.forEach((item) => {
            if (idsToRemove.includes(item.variant_id.toString())) {
              updates[item.key] = 0;
            }
          });

          if (Object.keys(updates).length > 0) {
            await fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ updates }),
            });
          }

          this.refresh();
        } catch (err) {
          console.error("Error removing items:", err);
        } finally {
          if (parentEl) {
            parentEl.classList.remove("pointer-events-none");
            parentEl.style.opacity = "1";
            const loader = parentEl.querySelector(".cart-item__loader");
            if (loader) loader.hidden = true;
          }
        }
      });
    }

    // ------------------ COUPON FORM ------------------
    initCouponForm() {
      const couponInput = this.querySelector('input[name="custom-discount-input"]');
      const couponApply = this.querySelector('.submit-discount');
      const couponError = this.querySelector('.custom-discount-form .error');
      const couponRemove = this.querySelectorAll('.remove-discount');

      if (couponError) couponError.style.display = 'none';

      if (couponApply && couponInput) {
        couponApply.addEventListener('click', async (e) => {
          e.preventDefault();

          const code = couponInput.value.trim();
          if (!code) {
            if (couponError) {
              couponError.innerText = 'Please enter a discount code';
              couponError.style.display = 'block';
            }
            return;
          }

          couponApply.disabled = true;
          const oldText = couponApply.innerText;
          couponApply.innerText = 'Applying...';
          if (couponError) couponError.style.display = 'none';

          try {
            const res = await fetch(`/discount/${encodeURIComponent(code)}`, { method: 'GET' });
            if (!res.ok && couponError) {
              couponError.innerText = 'Invalid discount code';
              couponError.style.display = 'block';
            }

            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          } catch (err) {
            console.error('Coupon apply error:', err);
            if (couponError) {
              couponError.innerText = 'Something went wrong, try again';
              couponError.style.display = 'block';
            }
          } finally {
            couponApply.disabled = false;
            couponApply.innerText = oldText;
          }
        });
      }

      if (couponRemove.length > 0) {
        couponRemove.forEach((btn) => {
          btn.addEventListener('click', async (e) => {
            e.preventDefault();
            btn.disabled = true;
            const oldHtml = btn.innerHTML;
            btn.innerHTML = '...';

            try {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
              });
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
            } catch (err) {
              console.error('Coupon remove error:', err);
            } finally {
              btn.disabled = false;
              btn.innerHTML = oldHtml;
            }
          });
        });
      }
    }

    // ------------------ SPECIFIC PRODUCT TOGGLE ------------------
    initSpecificProductEvent() {
      const specificVariantId = 46692864065836;
      const toggleBtn = this.querySelector(".toggle_button_atc");
      if (!toggleBtn) return;

      const LOCAL_STORAGE_KEY = `specific_product_removed_by_user_${specificVariantId}`;
      let isProcessing = false;

      const setRemovedState = (isRemoved) => localStorage.setItem(LOCAL_STORAGE_KEY, isRemoved ? 'true' : 'false');
      const getRemovedState = () => localStorage.getItem(LOCAL_STORAGE_KEY) === 'true';

      const setToggleActive = () => toggleBtn.classList.add("active");
      const setToggleInactive = () => toggleBtn.classList.remove("active");

      const refreshCartDrawer = () => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      const fetchCart = async () => await fetch("/cart.js").then(res => res.json());

      const addSpecificProduct = async (shouldRefresh = true) => {
        if (isProcessing) return;
        isProcessing = true;
        try {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: specificVariantId, quantity: 1 })
          });
          setRemovedState(false);
          setToggleActive();
          if (shouldRefresh) refreshCartDrawer();
        } catch (err) { console.error("Error adding specific product:", err); }
        finally { isProcessing = false; }
      };

      const removeSpecificProduct = async () => {
        if (isProcessing) return;
        isProcessing = true;
        try {
          setRemovedState(true);
          const cart = await fetchCart();
          const item = cart.items.find(i => i.id === specificVariantId);
          if (!item) { setToggleInactive(); refreshCartDrawer(); return; }

          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: { [item.key]: 0 } })
          });

          setToggleInactive();
          refreshCartDrawer();
        } catch (err) {
          console.error("Error removing specific product:", err);
          setRemovedState(false);
        } finally { isProcessing = false; }
      };

      const checkAndEnsureProduct = async () => {
        if (isProcessing) return;
        try {
          const cart = await fetchCart();
          const otherItemCount = cart.items.filter(i => i.id !== specificVariantId).reduce((sum, i) => sum + i.quantity, 0);
          const specificProductExists = cart.items.some(i => i.id === specificVariantId);
          const userHasRemoved = getRemovedState();

          if (specificProductExists && !otherItemCount) {
            const item = cart.items.find(i => i.id === specificVariantId);
            if (item) {
              await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates: { [item.key]: 0 } })
              });
              setRemovedState(false);
              setToggleInactive();
              refreshCartDrawer();
            }
            return;
          }

          if (userHasRemoved && specificProductExists) {
            const item = cart.items.find(i => i.id === specificVariantId);
            if (item) {
              await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates: { [item.key]: 0 } })
              });
              refreshCartDrawer();
            }
            setToggleInactive();
            return;
          }

          if (!specificProductExists && otherItemCount) await addSpecificProduct(true);
          else if (specificProductExists) setToggleActive();
          else setToggleInactive();
        } catch (err) { console.error("Error in checkAndEnsureProduct:", err); setToggleInactive(); }
      };

      toggleBtn.addEventListener("click", () => {
        if (isProcessing) return;
        if (toggleBtn.classList.contains("active")) removeSpecificProduct();
        else addSpecificProduct();
      });

      checkAndEnsureProduct();
      document.addEventListener('dispatch:cart-drawer:refresh', checkAndEnsureProduct);
    }

    handleSectionSelect(evt) { if (evt.target === this.closest('.shopify-section')) this.open(); }
    handleSectionDeselect(evt) { if (evt.target === this.closest('.shopify-section')) this.close(); }
    handleDrawerOpenViaEvent(evt) { this.open(evt.detail ? evt.detail.opener : null); }

    open(opener, elementToFocus) {
      const quickAddDrawer = document.querySelector('quick-add-drawer[aria-hidden="false"]');
      const overlay = document.querySelector('.js-overlay.is-visible');

      if (quickAddDrawer) {
        if (overlay) overlay.style.transitionDelay = '200ms';
        quickAddDrawer.close();
      }

      setTimeout(() => {
        super.open(opener, elementToFocus, () => {
          if (this.cartSummary.classList.contains('cart-drawer--checkout--sticky-true')) CartDrawer.recalculateCssVarHeights();
        });
        if (overlay) overlay.style.transitionDelay = '';
      }, quickAddDrawer ? 200 : 0);
    }

    async refresh(dontRefreshCartItems) {
      try {
        const cartItems = this.querySelector('cart-items');
        if (cartItems && !dontRefreshCartItems) cartItems.refresh();
        else {
          const response = this.getSectionsToRender().map(section => section.section);
          const cartResponse = await fetch(`?sections=${response.join(',')}`);
          const sections = await cartResponse.json();
          this.renderContents({ sections }, false);
          CartDrawer.recalculateCssVarHeights();
        }
      } catch (error) {
        console.log(error);
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: this.errorMsg?.textContent }
        }));
      }
    }

    async renderContents(data, openDrawer = true) {
      if (!this.scriptsLoaded) {
        if (!document.querySelector(`script[src="${theme.scripts.cartItems}"]`)) await loadScript(theme.scripts.cartItems);
        if (!document.querySelector(`script[src="${theme.scripts.shippingCalculator}"]`) && this.dataset.shippingCalculator) {
          await loadScript(theme.scripts.countryProvinceSelector);
          await loadScript(theme.scripts.shippingCalculator);
        }
        this.scriptsLoaded = true;
      }

      this.getSectionsToRender().forEach((section) => {
        const el = document.getElementById(section.id);
        if (el) el.innerHTML = CartDrawer.getElementHTML(data.sections[section.section], section.selector);
      });

      if (openDrawer && this.getAttribute('open') === null) setTimeout(() => this.open());
      this.initCouponForm();
      this.initSpecificProductEvent();
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', section: this.closest('.shopify-section').id.replace('shopify-section-', ''), selector: 'cart-drawer' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
      ];
    }

    static recalculateCssVarHeights() {
      window.requestAnimationFrame(() => {
        document.dispatchEvent(new CustomEvent('on:css-var-height:update'));
      });
    }

    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;
      return tmpl.content.querySelector(selector).innerHTML;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}
